/** Доли приходят строками (0..1) и показываются процентами.
 *
 * Строкой — потому что доля тоже число, которое нельзя терять: 0.0833 во float
 * становится 0.08330000000000001. Для показа округляем до целых процентов —
 * «8.33%» на экране читается хуже, чем «8%», а решение от третьего знака не меняется.
 */
export function percent(share: string, digits = 0): string {
  const value = Number(share);
  if (!Number.isFinite(value)) return "—";
  // Настоящий минус, а не дефис: рядом стоят суммы из formatMoney, где минус
  // именно такой, и «-6%» под «−422,31 $» выглядит как другой шрифт.
  return `${(value * 100).toFixed(digits).replace("-", "\u2212")}%`;
}

/** Ширина полосы, 0..100. Только для пикселей. */
export function widthOf(share: string): number {
  const value = Number(share);
  if (!Number.isFinite(value)) return 0;
  return Math.max(0, Math.min(value, 1)) * 100;
}
